import { lazy } from 'react';

import { Route, Routes } from 'react-router-dom';

import { TicketList } from './components/ticketList/TicketList';

const TicketDetailsPage = lazy(() => import('./pages/ticket-details.page'));

export const TicketsRoutes = () => {
  return (
    <Routes>
      <Route index element={<TicketList />} />
      <Route path=":ticketId" element={<TicketDetailsPage />} />
    </Routes>
  );
};
